import { useAsyncEffect } from '@xylabs/sdk-react'
import { PropsWithChildren, useContext, useEffect, useState } from 'react'

import { EthersContext } from '../Ethers'
import { AuthenticationContext } from './Context'
import XyoWorldEntity from './XyoWorldAuthenticatedEntity'
import XyoWorldAuthentication from './XyoWorldAuthentication'

interface Props {
  enabled?: boolean
}

export const AuthenticationLoader: React.FC<PropsWithChildren<Props>> = (props) => {
  const { children } = props
  const enabled = true
  const { signer } = useContext(EthersContext)

  const [auth, setAuth] = useState<XyoWorldAuthentication | null>()
  const [entity, setEntity] = useState<XyoWorldEntity | null>()

  useEffect(() => {
    if (enabled) {
      if (signer !== undefined) {
        setAuth(signer ? new XyoWorldAuthentication(signer) : null)
      }
    }
  }, [signer, enabled])

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      let entity
      if (auth && enabled) {
        const address = auth.address()
        if (address) {
          entity = new XyoWorldEntity(address)
          try {
            await entity.load(auth.token)
          } catch (ex) {
            entity = undefined
            console.error(ex)
          }
        }
      }
      if (!isMounted()) return
      setEntity(entity)
    },
    [auth, enabled],
  )

  const signIn = async () => {
    await auth?.signIn()
    setAuth(signer ? new XyoWorldAuthentication(signer) : null)
  }

  const signOut = () => {
    auth?.signOut()
    setAuth(signer ? new XyoWorldAuthentication(signer) : null)
  }

  return <AuthenticationContext.Provider value={{ auth, authEntity: entity, signIn, signOut }}>{children}</AuthenticationContext.Provider>
}
